import React from 'react';
import { Stack, Typography, Box, IconButton } from '@mui/material';
import AuthButton from '../../components/Button/AuthButton';
import VerticalGap from '../../components/Gap/VerticalGap';
import LabelButton from '../../components/Button/LabelButton';
import { DamsColors } from '../../components/styles/DamsColors';

interface CheckMailProps {
    onOpenEmailAppClick: () => void;
    onLabelButtonClick: () => void;
    pageProps: any;
}

const CheckMail: React.FC<CheckMailProps> = ({ onOpenEmailAppClick, onLabelButtonClick, pageProps }) => {
    return (
        <Stack
            // border={'1px solid red'}
        >

            <AuthButton
                title={pageProps?.BtnText}
                size={pageProps?.BtnType}
                showIcon={pageProps?.BtnIcon}
                onPress={() => onOpenEmailAppClick()} />

            <VerticalGap height={15} />

            <Box display={'flex'} alignItems={'center'} height={20}>
                <Typography
                    fontFamily={'Inter'}
                    fontSize={14}
                    fontWeight={400}
                    color={DamsColors.Authentication.IconColor}
                    mr={1}>
                    {"Didn’t receive the link?"}
                </Typography>
                <IconButton
                    disableRipple
                    disableFocusRipple
                >
                    <Typography
                        fontFamily={'Inter'}
                        fontSize={14}
                        fontWeight={600}
                        color={DamsColors.Authentication.Button}
                    >
                        Click to resend
                    </Typography>
                </IconButton>
            </Box>

            <VerticalGap height={20} />


            <Stack
                direction={'row'}
                gap={3}
                height={40}
            // border={'1px solid blue'}
            >
                <LabelButton
                    onPress={() => onLabelButtonClick()}
                    label={pageProps.infoLabelIconText}
                    direction={pageProps.labelDirection} />
            </Stack>

        </Stack>
    );
};

export default CheckMail;
